import { ObjectColumn } from '../types/grid';
import { ColumnOptions } from '../types/column-options';
import { ColumnHostRef } from '../types/refs';

export interface ObjectColumnOptions<TRow extends object, TValue extends object> extends ColumnOptions<TRow, TValue>{
  format: (value: TValue) => string;
  rowGroup?: boolean;
  sortBy: (value: TValue) => number | string;
}

export function objectColumn<TRow extends object, TValue extends object>(ref: ColumnHostRef<TRow>,
                                                                         options: ObjectColumnOptions<TRow, TValue>): ObjectColumn<TRow, TValue> {
  const column: ObjectColumn<TRow, TValue> = {
    ...options,
    type: 'object',
  }
  ref.createColumn(column as any);
  return column;
}
